
import {
  AUTH_ERROR,
  SAVE_AUTH_RESPONSE,
  SAVE_CHANGE_PASSWORD_RESPONSE,
  SAVE_CLIENT_DETAIL_INFO,
  SAVE_FORGOT_PASSWORD_RESPONSE,
  TOKEN_SAVE,
  SET_APP_IS_IMPERSONATE,
  SET_LINKED_ACCOUNT_LIST,
  SAVE_PARENT_INFO
} from '../actions/types';

const initialState = {
  Token: '',
  errorMeesage: null,
  authResponse: {},
  authClientDetailedInfo: {},
  appIsImpersonate: false,
  linkedAccountsListData: {},
  parentInfo:{}
};

export const AuthReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case TOKEN_SAVE:
      return {
        ...state,
        Token: payload,
      };

    case SAVE_AUTH_RESPONSE:
      return {
        ...state,
        authResponse: payload,
      };

    case AUTH_ERROR:
      return {
        ...state,
        errorMeesage: payload,
      };
    case SAVE_CLIENT_DETAIL_INFO:
      return {
        ...state,
        authClientDetailedInfo: payload,
      };

    case SAVE_FORGOT_PASSWORD_RESPONSE:
      return {
        ...state,
        forgotPasswordResponse: payload,
      };
    case SAVE_CHANGE_PASSWORD_RESPONSE:
      return {
        ...state,
        changePasswordResponse: payload,
      };
    case SET_APP_IS_IMPERSONATE: 
      return {
        ...state,
        appIsImpersonate: payload
      }

      case SET_LINKED_ACCOUNT_LIST: 
      return {
        ...state,
        linkedAccountsListData: payload
      }

      case SAVE_PARENT_INFO: 
      return {
        ...state,
        parentInfo: payload
      }
      
      
      
    default:
      return { ...state };
  }
};
